import type { AuthenticatedSession, SessionSidebarItem } from "./authenticated-session";
import { hasSalePermission, type SalePermission } from "./sale-permissions";

const modules: Record<string, { path: string; permission: SalePermission }> = {
  sale_management: { path: "/sale-support/sales", permission: "sale_management_view" },
  global_configuration: { path: "/sale-support/settings", permission: "global_configuration_view" },
  lead_management: { path: "/sale-support/leads", permission: "lead_management_view" },
};

export function saleNavigation(session: AuthenticatedSession | null) {
  const result: { code: string; name: string; path: string }[] = [];
  const seen = new Set<string>();
  function visit(items: SessionSidebarItem[]) {
    for (const item of [...items].sort((a, b) => (a.sequence ?? 0) - (b.sequence ?? 0))) {
      if (item.sidebar !== true || item.code === "user_management" || item.code.startsWith("user_management_")) continue;
      const module = modules[item.code];
      if (module && hasSalePermission(session, module.permission) && !seen.has(item.code)) {
        result.push({ code: item.code, name: item.name, path: module.path });
        seen.add(item.code);
      }
      if (Array.isArray(item.children)) visit(item.children);
    }
  }
  visit(session?.sidebar ?? []);
  return result;
}
